import React from 'react';
import { FadeIn, SectionDivider } from '../ui';
import { AlertTriangle, Eye, Flame } from 'lucide-react';
export const ProblemSections = () => {
  return <div className="bg-mystic-900 relative" data-id="element-247">
      {/* BLOQUE 2: EL DOLOR */}
      <section className="py-20 px-4 relative overflow-hidden" data-id="element-248">
        <div className="absolute top-0 right-0 w-full md:w-1/2 h-full opacity-10 pointer-events-none" data-id="element-249">
          <img src="https://cdn.magicpatterns.com/uploads/mLt6zmWg4iG7hGKFnK4MFL/bloque_del_dolor.png" alt="Libro ancestral" className="w-full h-full object-cover object-left mask-image-linear-left" style={{
          WebkitMaskImage: 'linear-gradient(to left, black, transparent)'
        }} data-id="element-250" />
        </div>

        <div className="max-w-3xl mx-auto relative z-10" data-id="element-251">
          <FadeIn data-id="element-252">
            <div className="relative mb-12 rounded-2xl overflow-hidden border border-gold/15 shadow-[0_20px_60px_rgba(0,0,0,0.6)]" data-id="element-253">
              <img src="https://cdn.magicpatterns.com/uploads/41gTqu3yHnDdMHNXaXR1hz/ChatGPT_Image_22_may_2026,_09_25_37_p.m..png" alt="Mujer sola en la noche revisando su teléfono" className="w-full h-auto object-cover" data-id="element-254" />
              <div className="absolute inset-0 bg-gradient-to-t from-mystic-900 via-mystic-900/30 to-transparent pointer-events-none" data-id="element-255"></div>
              <div className="absolute inset-0 bg-gradient-to-r from-mystic-900/40 via-transparent to-mystic-900/40 pointer-events-none" data-id="element-256"></div>
            </div>
          </FadeIn>
          <FadeIn data-id="element-257">
            <div className="space-y-6 text-lg md:text-xl text-text-secondary leading-relaxed font-serif italic" data-id="element-258">
              <p data-id="element-259">
                ¿Cuántas veces has revisado su WhatsApp sabiendo que no hay nada
                nuevo?
              </p>
              <p data-id="element-260">
                ¿Cuántas noches te dormiste con el teléfono en la mano esperando
                un mensaje que no llegó?
              </p>
              <p data-id="element-261">Ese vacío en el pecho que no desaparece con nada.</p>
              <p data-id="element-262">Esa sensación de que algo fue roto injustamente.</p>
              <p data-id="element-263">
                De que si tan solo pudieran hablar cinco minutos, todo volvería
                a su lugar.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="mt-12 space-y-6 text-text-primary" data-id="element-264">
            <p data-id="element-265">En medio de ese dolor buscaste ayuda.</p>
            <p data-id="element-266">
              Quizás fue un "Maestro" en Facebook. Una "Vidente" en TikTok con
              miles de seguidores y fotos de testimonios que parecían reales. Te
              prometieron resultados en 72 horas.
            </p>
            <p data-id="element-267">
              Te pidieron dinero para "materiales especiales", "limpiezas de
              energía", "refuerzos".
            </p>
            <p className="font-bold text-xl mt-8" data-id="element-268">¿El resultado? Cero.</p>
            <p data-id="element-269">
              O peor: te dijeron que la energía negativa era "más fuerte de lo
              esperado" y que necesitabas pagar más para terminar el trabajo.
            </p>

            <div className="mt-10 p-6 border-l-2 border-burgundy bg-burgundy/5" data-id="element-270">
              <p className="text-2xl font-serif text-white" data-id="element-271">
                Eso no fue un ritual.
              </p>
              <p className="text-2xl font-serif text-burgundy font-bold mt-2" data-id="element-272">
                Eso fue un robo.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-273" />

      {/* BLOQUE 3: EL VILLANO */}
      <section className="py-12 px-4" data-id="element-274">
        <div className="max-w-3xl mx-auto" data-id="element-275">
          <FadeIn data-id="element-276">
            <div className="flex items-center gap-3 mb-8" data-id="element-277">
              <Eye className="text-gold" size={28} data-id="element-278" />
              <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-279">
                La verdad incómoda que nadie te dice
              </h2>
            </div>

            <div className="space-y-6 text-lg text-text-secondary" data-id="element-280">
              <p data-id="element-281">
                Quiero que entiendas algo que nadie te ha dicho con honestidad:
              </p>
              <p className="text-xl text-gold font-serif" data-id="element-282">
                Los brujos modernos necesitan que sigas sufriendo.
              </p>
              <p data-id="element-283">
                Su negocio no es devolverte a tu pareja.
                <br data-id="element-284" />
                Su negocio es tu desesperación.
              </p>
              <p data-id="element-285">
                Mientras más desesperado/a estés, más pagas. Y ellos lo saben
                perfectamente.
              </p>

              <ul className="space-y-4 mt-8 glass-panel p-8 rounded-xl" data-id="element-286">
                <li className="flex gap-3" data-id="element-287">
                  <span className="text-burgundy mt-1" data-id="element-288">✗</span>
                  <span data-id="element-289">
                    Por eso inventan el "trabajo con materiales especiales de
                    $300".
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-290">
                  <span className="text-burgundy mt-1" data-id="element-291">✗</span>
                  <span data-id="element-292">
                    Por eso te dicen que hay "entidades oscuras bloqueando tu
                    amor" que solo ellos pueden limpiar.
                  </span>
                </li>
                <li className="flex gap-3" data-id="element-293">
                  <span className="text-burgundy mt-1" data-id="element-294">✗</span>
                  <span data-id="element-295">
                    Por eso el amarre "casi funcionó pero necesita un refuerzo".
                  </span>
                </li>
              </ul>

              <p className="mt-8" data-id="element-296">
                Es un ciclo diseñado para vaciarte el bolsillo mientras el
                tiempo pasa.
              </p>
              <p data-id="element-297">
                Y mientras tú esperas ese milagro que nunca llega porque pagaste
                a un extraño para que hiciera lo que solo tú puedes hacer, la
                persona que amas sigue su vida.
              </p>

              <p className="text-2xl font-bold text-white mt-8" data-id="element-298">
                Hoy eso se termina.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-299" />

      {/* BLOQUE 4: PARA QUIÉN ES ESTO */}
      <section className="py-12 px-4 relative" data-id="element-300">
        <div className="absolute inset-0 bg-radial-glow opacity-30 pointer-events-none" data-id="element-301"></div>
        <div className="max-w-4xl mx-auto relative z-10" data-id="element-302">
          <FadeIn data-id="element-303">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-304">
              Esto es para ti si...
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-305">
              {['Tu pareja se alejó de repente sin una razón clara, como si algo hubiera cambiado en él/ella de un día para otro.', 'Sospechas que una tercera persona, los celos de alguien cercano o una envidia externa interfirieron en tu relación.', 'Ya le pagaste a un "maestro" o "vidente" y no obtuviste ningún resultado real — solo más gastos.', 'Tu ex te bloqueó, dejó de responder o desapareció dejándote sin ningún cierre.', 'Sientes que la conexión entre ustedes todavía existe, pero algo o alguien la está bloqueando.'].map((text, idx) => <div key={idx} className="glass-panel p-6 rounded-xl flex gap-4 items-start hover:border-gold/40 transition-colors" data-id="element-306">
                  <div className="text-gold mt-1" data-id="element-307">
                    <Flame size={20} data-id="element-308" />
                  </div>
                  <p className="text-text-primary" data-id="element-309">{text}</p>
                </div>)}
            </div>

            <div className="mt-12 text-center" data-id="element-310">
              <p className="text-xl text-gold font-serif italic" data-id="element-311">
                Si te identificas con al menos una de estas situaciones,
                <br data-id="element-312" />
                lo que vas a leer a continuación puede cambiar todo.
              </p>
            </div>
          </FadeIn>
        </div>
      </section>

      <SectionDivider data-id="element-313" />

      {/* BLOQUE 5: EL GIRO */}
      <section className="py-12 px-4" data-id="element-314">
        <div className="max-w-3xl mx-auto text-center" data-id="element-315">
          <FadeIn data-id="element-316">
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 leading-tight" data-id="element-317">
              Por qué tú eres el único que puede traerlo/a de regreso
            </h2>

            <div className="space-y-6 text-lg text-text-secondary text-left" data-id="element-318">
              <p data-id="element-319">
                Aquí está lo que los falsos maestros te ocultan deliberadamente:
              </p>
              <p className="text-xl text-white font-medium" data-id="element-320">
                La energía que te une a esa persona no puede ser manipulada por
                un extraño.
              </p>
              <p data-id="element-321">
                Los maestros originales — los que desarrollaron estas prácticas
                siglos antes de que existieran los "brujos de Instagram" —
                sabían algo fundamental:
              </p>

              <div className="py-8 my-8 border-y border-gold/20 text-center" data-id="element-322">
                <p className="text-2xl md:text-3xl font-serif text-gold italic" data-id="element-323">
                  El hilo que une dos almas solo puede ser jalado
                  <br data-id="element-324" />
                  por alguien que forma parte de ese hilo.
                </p>
                <p className="text-xl font-bold text-white mt-4 uppercase tracking-widest" data-id="element-325">
                  Ese alguien eres TÚ.
                </p>
              </div>

              <p data-id="element-326">
                Cuando un extraño intenta hacer un amarre por ti, el universo lo
                detecta como un intruso. Una persona sin ningún cordón
                energético con tu ser amado, haciendo movimientos vacíos en una
                habitación oscura.
              </p>
              <p data-id="element-327">
                Por eso siempre fallan. Por eso siempre piden más dinero para el
                "refuerzo".
              </p>

              <div className="mt-10 bg-mystic-800 p-8 rounded-xl text-center border border-gold/10" data-id="element-328">
                <p className="text-lg" data-id="element-329">
                  El ritual que vas a tener en tus manos nació de un linaje que
                  entendía que el amor no se mendiga.
                </p>
                <p className="text-3xl font-serif font-bold text-gold mt-4" data-id="element-330">
                  Se reclama.
                </p>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>
    </div>;
};